// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.thread_summary {
    display: flex;
    flex-direction: row;
    padding: 10px;
    border-radius: 10px;
    margin-top: 10px;
    margin-bottom: 10px;
    background-color: #f2f2f2;
    margin-left: 10px;
    box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
}

.thread_container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin-bottom: 40px;
    
}

.thread {
    width: 95%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-color: #f2f2f2;
    padding-bottom: 20px;
    border-radius: 20px;
    /* box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px; */
    box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
    /* box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px; */
    z-index: 10;
}



.thread_subject_container{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 96%;
    margin-bottom: 10px;
    margin-top:5px;
    /* border-radius: 20px; */
    padding: 15px 15px 10px 5px;
    /* box-shadow: rgba(50, 50, 93, 0.15) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px; */
    
}

.thread_subject{
    font-size: 18px;
    font-weight: bold;
    color: #0c0c0c;
}

.thread_subject_time {
    font-size: 15px;
    color: #7e7f81;
}



.box-shadow {
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
    padding: 10px;
    margin: 10px;
    border-radius: 10px;
    margin-top: 10px;
    
}


.email_thread {
    display: flex;
    flex-direction: column;
    width: 95%;
    padding-left: 2%;
    padding-right: 2%;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
    padding-top: 18px;
    margin-bottom: 8px;
    border-radius: 10px;
    background-color: white;
    padding-bottom: 10px
}

.email_view_email_thread {
    background-color:#fffefc;
    display: flex;
    flex-direction: column;
    width: calc(100% - 20px);
    padding-left: 2%;
    padding-right: 2%;
    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
    padding-top: 18px;
    margin-bottom: 50px;
    border-radius: 10px;
    padding-bottom: 10px;
    margin-left:10px;
    margin-right: 10px;
    border: 2px solid #ddc9ac;
}

.email_address{
    color: #7e7f81;
    text-decoration: none;
    cursor: pointer;
    font-size: 12px;
}

.email_hedaer_container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.email_address_list_container {
    display: flex;
    flex-direction: column;
    width: 80%;
    padding-right: 3%;

}

.verification-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 600px;
    padding: 100px;
    border-radius: 10px;
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #f2f2f2;
    margin-left: 10px;
    
}

.verification-input {
    width: 80px;
    height: 80px;
    padding: 10px;
    border-radius: 10px;
    border: none;
    margin-right: 10px;
    box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
    text-align: center;
    font-size: 25px;
}

.verification-input:focus {
    border: 1px solid #007bff;
}`, "",{"version":3,"sources":["webpack://./src/app/communication-history/communication-history.component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,yFAAyF;AAC7F;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,mBAAmB;;AAEvB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,yBAAyB;IACzB,oBAAoB;IACpB,mBAAmB;IACnB,+FAA+F;IAC/F,yFAAyF;IACzF,sFAAsF;IACtF,WAAW;AACf;;;;AAIA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,UAAU;IACV,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,2BAA2B;IAC3B,8FAA8F;;AAElG;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;;;AAIA;IACI,wFAAwF;IACxF,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;;AAEpB;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,wFAAwF;IACxF,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB;AACJ;;AAEA;IACI,wBAAwB;IACxB,aAAa;IACb,sBAAsB;IACtB,wBAAwB;IACxB,gBAAgB;IAChB,iBAAiB;IACjB,yFAAyF;IACzF,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,iBAAiB;;AAErB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;;AAErB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,yFAAyF;IACzF,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".thread_summary {\n    display: flex;\n    flex-direction: row;\n    padding: 10px;\n    border-radius: 10px;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    background-color: #f2f2f2;\n    margin-left: 10px;\n    box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;\n}\n\n.thread_container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    margin-bottom: 40px;\n    \n}\n\n.thread {\n    width: 95%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    background-color: #f2f2f2;\n    padding-bottom: 20px;\n    border-radius: 20px;\n    /* box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px; */\n    box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;\n    /* box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px; */\n    z-index: 10;\n}\n\n\n\n.thread_subject_container{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    width: 96%;\n    margin-bottom: 10px;\n    margin-top:5px;\n    /* border-radius: 20px; */\n    padding: 15px 15px 10px 5px;\n    /* box-shadow: rgba(50, 50, 93, 0.15) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px; */\n    \n}\n\n.thread_subject{\n    font-size: 18px;\n    font-weight: bold;\n    color: #0c0c0c;\n}\n\n.thread_subject_time {\n    font-size: 15px;\n    color: #7e7f81;\n}\n\n\n\n.box-shadow {\n    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;\n    padding: 10px;\n    margin: 10px;\n    border-radius: 10px;\n    margin-top: 10px;\n    \n}\n\n\n.email_thread {\n    display: flex;\n    flex-direction: column;\n    width: 95%;\n    padding-left: 2%;\n    padding-right: 2%;\n    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;\n    padding-top: 18px;\n    margin-bottom: 8px;\n    border-radius: 10px;\n    background-color: white;\n    padding-bottom: 10px\n}\n\n.email_view_email_thread {\n    background-color:#fffefc;\n    display: flex;\n    flex-direction: column;\n    width: calc(100% - 20px);\n    padding-left: 2%;\n    padding-right: 2%;\n    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;\n    padding-top: 18px;\n    margin-bottom: 50px;\n    border-radius: 10px;\n    padding-bottom: 10px;\n    margin-left:10px;\n    margin-right: 10px;\n    border: 2px solid #ddc9ac;\n}\n\n.email_address{\n    color: #7e7f81;\n    text-decoration: none;\n    cursor: pointer;\n    font-size: 12px;\n}\n\n.email_hedaer_container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.email_address_list_container {\n    display: flex;\n    flex-direction: column;\n    width: 80%;\n    padding-right: 3%;\n\n}\n\n.verification-container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    width: 600px;\n    padding: 100px;\n    border-radius: 10px;\n    margin-top: 30px;\n    margin-bottom: 10px;\n    background-color: #f2f2f2;\n    margin-left: 10px;\n    \n}\n\n.verification-input {\n    width: 80px;\n    height: 80px;\n    padding: 10px;\n    border-radius: 10px;\n    border: none;\n    margin-right: 10px;\n    box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;\n    text-align: center;\n    font-size: 25px;\n}\n\n.verification-input:focus {\n    border: 1px solid #007bff;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
